import React, { useState } from "react";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import Color from "../../../../../utils/Color";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../../../components/CustomText";
import CustomTextInput from "../../../../components/CustomTextInput";
import CustomButton from "../../../../components/CustomButton";
import HelpIcon from "@material-ui/icons/Help";
import useMediaQuery from "@material-ui/core/useMediaQuery/useMediaQuery";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import AuthManager from "../../../../../utils/AuthManager";

const StyledTooltip = withStyles({
  tooltip: {
    color: Color.secondaryTextColor,
    backgroundColor: Color.backgroundColor,
    ...getFontWeight("normal"),
    ...getFontSize("small"),
  },
})(Tooltip);

const BlueOnGreenTooltip = withStyles({
  tooltip: {
    color: "#74788D",
    backgroundColor: "#FFEDB9",
    minWidth: "100px",
    
  },
  arrow:{
    fontSize: 10,
    width:"10px",
    color: "#FFEDB9",
    "&::before": {
      backgroundColor: "#FFEDB9",
      //border: "2px solid red"
    }
  }
})(Tooltip);

const BlueOnGreenTooltip2 = withStyles({
  tooltip: {
    color: "#74788D",
    backgroundColor: "#FFEDB9",
    //minWidth: "400px",
    
  }
})(Tooltip);

const useStyles = makeStyles((theme) => ({
  tooltipContainer: {
    display: "flex",
  },
  infoIconStyle: {
    width: "20x",
    height: "20px",
    color: "#00B4AF",
    marginLeft: 10,
  },
  infoIconStyleV2: {
    width: "20x",
    height: "20px",
    color: "#FEC31A",
    marginLeft: 10,
  },
  tooltipTextStyle: {
    color: Color.secondaryTextColor,
    ...getFontWeight("normal"),
    [theme.breakpoints.up("xs")]: {},
    [theme.breakpoints.up("lg")]: {
      width: 190,
      height: 18,
    },
  },
  labelTextInputTextStyle: {
    ...getFontWeight("600"),
    ...getFontSize("medium"),
    color: Color.primaryTextColor,
  },
  textInputContainer: {
    height: 40,
    marginBottom: 25,
    marginTop: 5,
  },
  headerTextStyle: {
    ...getFontWeight("800"),
    fontSize: 28,
    textAlign: "left",
    color: "#2c3034",
  },
  inputContentContainer: {
    marginTop: 40,
    marginBottom: 10,
  },
  buttonStyle: {
    width: 120,
    //marginBottom: 20,
  },
  highLightedTextStyle: {
    color: "#1858b9",
    ...getFontSize("small"),
    ...getFontWeight("600"),
    // fontFamily: "Muli",
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
  descTextStyle: {
    color: "#818181",
    ...getFontSize("small"),
    ...getFontWeight("600"),
  },
  backButton: {
    width: 120,
    marginTop: 0,

    borderColor: Color.primaryTextColor,
    backgroundColor: "transparent",
    color: Color.primaryTextColor,
    opacity: 0.6,
    "&:hover": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
    },
    "&:focus": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
      opacity: 1.0,
    },
  },
  backButtonTextStyle: {
    fontFamily: "Muli",
    ...getFontSize("medium"),
    ...getFontWeight("bold"),
  },
  tooltipTextStyle1: {
    color: "#74788D",
    //opacity: 0.45,
    fontSize:"12px",
    fontWeight:"400",
    padding:2,
    lineHeight:1.6,
    paddingLeft:5
    //background:"red"
    
  },
  tooltipTextStyle2: {
    color: "#74788D",
    //opacity: 0.45,
    fontSize:"12px",
    fontWeight:"400",
    //padding:2,
    //lineHeight:1.6,
    //paddingLeft:5
    //background:"red"
    
  },
}));

function ActivateAccount({
  nric,
  onChangeNRIC,
  onClickNext,
  onClickContactUs,
  onClickBack,
  handleKeypress,
}) {
  const classes = useStyles();
  const theme = useTheme();
  const matchesMD = useMediaQuery(theme.breakpoints.down("md"));
  const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));

  const [selectedTooltip, setSelectedTooltip] = useState("");
 

  const handleTooltipOpen = (item) => {
    if (selectedTooltip !== item) {
      setSelectedTooltip(item);
    } else {
      setSelectedTooltip("");
    }
  };

  const [open, setOpen] = React.useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen1 = () => {
    setOpen(true);
  };

  const renderTooltip = (item) => {
    if (!matchesMD) {
      return (
        <StyledTooltip
          title={
            <CustomText design={classes.tooltipTextStyle}>
              {<b>e.g </b>}S1234567A, F1234567A
            </CustomText>
          }
          placement="right-start"
        >
          <HelpIcon className={classes.infoIconStyleV2} />
        </StyledTooltip>
      );
    } else {
      return (
        <div>
          <StyledTooltip
            PopperProps={{
              disablePortal: true,
            }}
            open={selectedTooltip === item}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            title={
              <CustomText design={classes.tooltipTextStyle}>
                 {<b>e.g </b>}S1234567A, F1234567A
              </CustomText>
            }
            placement={!matchesSM ? "right-start" : "bottom"}
          >
            <HelpIcon
              className={classes.infoIconStyleV2}
              onClick={() => handleTooltipOpen(item)}
            />
          </StyledTooltip>
        </div>
      );
    }
  };

  const renderTooltip1 = () => {
   
    if (!matchesMD) {
      return (
        <BlueOnGreenTooltip title={
          <CustomText design={classes.tooltipTextStyle1}>
            {<b>e.g </b>}S1234567A, F1234567A
          </CustomText>
        } placement="right"  arrow>
        <HelpIcon className={classes.infoIconStyleV2}  />
      </BlueOnGreenTooltip>
       
      );
    } else {
      return (
        <ClickAwayListener onClickAway={handleTooltipClose}>
          <BlueOnGreenTooltip2
            PopperProps={{
              disablePortal: true,
            }}
            onClose={handleTooltipClose}
            open={open}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            title={
              <CustomText design={classes.tooltipTextStyle2}>
                 {<b>e.g </b>}S1234567A, F1234567A
              </CustomText>
            }
            // placement={!matchesSM ? "right-start" : "bottom-end"}
            placement={"right"}
          >
            <HelpIcon
              className={classes.infoIconStyleV2}
              onClick={handleTooltipOpen1}
            />
          </BlueOnGreenTooltip2>
        </ClickAwayListener>
      );
    }
  };

  return (
    <div>
      <CustomText design={classes.headerTextStyle}>
        Registration / Activation
      </CustomText>
      <div className={classes.inputContentContainer}>
        <CustomTextInput
          title={"NRIC/Passport/FIN No."}
          textstyle={classes.labelTextInputTextStyle}
          design={classes.textInputContainer}
          fullWidth={true}
          value={nric}
          onChange={onChangeNRIC}
          tooltip={renderTooltip1()}
          onKeyUp={handleKeypress}
        />
      </div>

      {/* <CustomButton
        title={"Next"}
        design={classes.buttonStyle}
        onClick={onClickNext}
      />

      <CustomButton
        title={"Next"}
        design={classes.buttonStyle}
        onClick={onClickNext}
      /> */}

      <div style={{ paddingRight: "1em", display: "inline-block" }}>
        <CustomButton
          title={"Back"}
          design={classes.backButton}
          textstyle={classes.backButtonTextStyle}
          onClick={onClickBack}
        />
      </div>
      <div style={{ display: "inline-block" }}>
        <CustomButton
          title={"Next"}
          design={classes.buttonStyle}
          onClick={onClickNext}
        />
      </div>

      {/* <div style={{ marginTop: 15 }}>
        <CustomText design={classes.descTextStyle} component="div">
          If any of the information does not tally with your records with us,
          registration will fail. Please{" "}
          <CustomText
            display={"inline"}
            design={classes.highLightedTextStyle}
            onClick={onClickContactUs}
          >
            Contact Us{" "}
          </CustomText>
          for further assistance.
        </CustomText>
      </div> */}
    </div>
  );
}
export default ActivateAccount;
